import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from '../cx';
/**
 * 基础按钮。`type` 默认 `button`(防止在表单里误提交),需要提交按钮时显式传
 * `type="submit"`。其余 props 透传原生 <button>。
 */
export function Button({ variant = 'primary', size = 'md', loading = false, fullWidth = false, disabled, type = 'button', className, children, ref, ...rest }) {
    const { 'aria-busy': ariaBusyProp, ...buttonRest } = rest;
    return (_jsxs("button", { ...buttonRest, ref: ref, type: type, disabled: disabled || loading, "aria-busy": loading || ariaBusyProp || undefined, className: cx('wv-btn', `wv-btn--${variant}`, `wv-btn--${size}`, fullWidth && 'wv-btn--block', className), children: [loading && _jsx("span", { className: "wv-btn__spinner", "aria-hidden": "true" }), children] }));
}
